import React from 'react';
import { DateTime } from "luxon";
import { Typography } from "@mui/material";
import ScrollAwareTooltip from 'components/Custom/ScrollAwareTooltip';

const TimezoneDisplay = ({ user, myUserTimezone }) => {
    // Get current times in both user's timezone and your own timezone
    const userDateTime = DateTime.now().setZone(user.timezone);
    const myDateTime = DateTime.now().setZone(myUserTimezone);

    // Format both times for display (e.g., 14:30)
    const userTimeFormatted = userDateTime.toFormat("HH:mm");
    const myTimeFormatted = myDateTime.toFormat("HH:mm");

    // Get UTC offset for user's timezone
    const userOffset = userDateTime.offset;
    const offsetHours = Math.floor(Math.abs(userOffset) / 60);
    const userOffsetString = `UTC${userOffset >= 0 ? "+" : "-"}${String(offsetHours).padStart(2, "0")}:00`;

    // Get UTC offset for my timezone
    const myOffset = myDateTime.offset;
    const myOffsetHours = Math.floor(Math.abs(myOffset) / 60);
    const myOffsetString = `UTC${myOffset >= 0 ? "+" : "-"}${String(myOffsetHours).padStart(2, "0")}:00`;

    // Calculate the time difference based on UTC offsets in hours only
    const offsetDifferenceInHours = Math.floor(Math.abs(myOffset - userOffset) / 60);
    const timeDifferenceString = myOffset > userOffset
        ? `${offsetDifferenceInHours} hours behind`
        : `${offsetDifferenceInHours} hours ahead`;

    // Tooltip content with UTC offsets
    const tooltipContent = (
        <span style={{ display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: "#3d393b", padding: "10px", borderRadius: "8px" }}>
            <Typography variant="subtitle1" style={{ color: "#e0e0e0" }}>My Time: {myTimeFormatted}</Typography>
            <Typography variant="body2" style={{ color: "#80caff", fontStyle: "italic" }}>({myUserTimezone} {myOffsetString})</Typography>
            <Typography variant="subtitle1" style={{ color: "#e0e0e0" }}>Their Time: {userTimeFormatted}</Typography>
            <Typography variant="body2" style={{ color: "#80caff", fontStyle: "italic" }}>({user.timezone} {userOffsetString})</Typography>
            <Typography variant="body2" style={{ color: timeDifferenceString.includes("behind") ? "#4caf50" : "#f44336", marginTop: "8px" }}>
                Time Difference: {timeDifferenceString}
            </Typography>
        </span>
    );

    return (
        <ScrollAwareTooltip 
            title={tooltipContent} 
            arrow 
            PopperProps={{
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [0, 10],
                        },
                    },
                ],
                sx: {
                    "& .MuiTooltip-tooltip": {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        padding: 0,
                    }
                },
            }}
        >
            <Typography variant="body2" className="white-txt-color">
                {user.timezone} {userOffsetString} <br /> ({timeDifferenceString})
            </Typography>
        </ScrollAwareTooltip>
    );
};

export default TimezoneDisplay;
